export default "__VITE_ASSET__DyRao29d__"